import { createApi } from '@reduxjs/toolkit/query/react';
import { appConfig } from 'src/config';
import { capacitorBaseQuery } from './capacitor-adapter';

export const emptyDeinVerbandApi = createApi({
  baseQuery: capacitorBaseQuery({
    baseUrl: appConfig.baseUrl || '',
    enableAuth: true
  }),
  endpoints: () => ({}),
  reducerPath: 'deinVerbandApi'
});

export const emptyPreflightApi = createApi({
  baseQuery: capacitorBaseQuery({
    baseUrl: appConfig.baseUrl || '',
    enableAuth: true,
    abacPreflight: true
  }),
  endpoints: () => ({}),
  reducerPath: 'preflightApi'
});
